import { render } from "./QIconButton.vue?vue&type=template&id=2cd136e9"
import script from "./QIconButton.vue?vue&type=script&lang=js"
export * from "./QIconButton.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__